module.exports = __webpack_public_path__ + "static/seo-korobox-42138770313ebadb81341d4eae1875e0.png";